import store from '@data/store/Store';
import { distinctBy } from '../lo/lo';

export const getMenuCategories = () => {
  const place = store.getState().place.details?.data;

  if (place?.dishes?.length > 0) {
    const categories = place.dishes
      .flatMap(dish => dish.menus)
      .filter(category => !category.parent)
      .concat(place.dishes.flatMap(d => d.menus).filter(c => c.parent).map(c => c.parent))
      .filter(distinctBy('id'))
      .map(c => ({ ...c, subcategories: [] }))
      .sort((d1, d2) => d1.order - d2.order);

    place.dishes
      .flatMap(dish => dish.menus)
      .filter(category => category.parent)
      .filter(distinctBy('id'))
      .forEach(child => categories.find(c => c.id === child.parent.id)?.subcategories.push(child));

    return categories;
  } else {
    return [];
  }
};

export const getCategoryDishes = (category) => {
  const place = store.getState().place.details?.data;

  if (place?.dishes?.length > 0 && category) {
    return place.dishes
      .filter(dish => dish.menus.find(c => c.id === category.id || category.parent?.slug === c.slug));
  } else {
    return [];
  }
};

export const getLikedDishes = () => {
  const place = store.getState().place.details?.data;
  const dishes = place?.dishes || [];
  return dishes.filter(d => d.isLiked);
};

export const getPlaceOrders = () => {
  const place = store.getState().place.details?.data;
  const orders = store.getState().place.menu;
  const dishes = place?.dishes || [];
  return (orders[place?.uri] || []).filter(o => dishes.find(d => d.id === o.id));
};

export const getOrderAmount = () => {
  const place = store.getState().place.details?.data;
  const dishes = place?.dishes || [];
  return getPlaceOrders()
    .map(o => {
      const dish = dishes.find(d => d.id === o.id);
      return dish.price * o.quantity;
    })
    .reduce((acc, val) => acc + val, 0);
};
